import { PayloadAction } from "@reduxjs/toolkit";
import { call, CallEffect, put, PutEffect } from "redux-saga/effects";
import { updateDocumentAddress } from "../api/documentsApi";
import { updateDocumentAddressFailure } from "./documentsSlice";

export function* handleUpdateDocumentAddress(
  action: PayloadAction<{ documentId: string; address: string }>
): Generator<CallEffect | PutEffect, void, any> {
  try {
    yield call(
      updateDocumentAddress,
      action.payload.documentId,
      action.payload.address
    );
  } catch (error) {
    yield put(
      updateDocumentAddressFailure(
        error instanceof Error ? error.message : "Address update failed"
      )
    );
  }
}
